export const NAVIGATION_ID_MAP_WITH_DEALERS = Object.freeze({
    'configuration-wizard__versions': 'versions',
    'configuration-wizard__color': 'color',
    'configuration-wizard__dealers': 'dealers',
    'configuration-wizard__price': 'price',
});

export const NAVIGATION_ID_MAP_WITHOUT_DEALERS = Object.freeze({
    'configuration-wizard__versions': 'versions',
    'configuration-wizard__color': 'color',
    'configuration-wizard__price': 'price',
});
